module.exports = __webpack_public_path__ + "img/forword_no.6434b147.png";